import {TakeTruffle} from './takeTruffle.model';

export class User {
  id: string;
  salutation: string;
  firstName: string;
  lastname: string;
  email: string;
  address: string;
  city: string;
  postcode: string;
  phone: string;
  sponsoringSince: string;
  treeReferences: string[] = [];
  role?: string;
  takeTruffle: TakeTruffle[] = [];
  pushTokens?: string[];
  treeReferenceDates?: {[reference: string]: string};
}
